/**
 * getCredentials module
 * calls getCurrent user then gets session tokens which are then used to get user credentials
 */

import schoolConstants from '../constants/schoolConstants';
import getCurrentUser from './getCurrentUser';

function getCredentials() {
  var cognitoUser = getCurrentUser();
  if (cognitoUser == null) return Promise.reject(new Error('Unable to get current user'));

  var credentialsPromise = new Promise(function (resolve, reject) {
    cognitoUser.getSession(function (err, session) {
      if (err) {
        reject(err);
        return;
      }

      var idToken = session.getIdToken().getJwtToken();

      // Add the User's Id Token to the Cognito credentials login map.
      var login =
        'cognito-idp.us-east-1.amazonaws.com/' +
        schoolConstants[localStorage.zmailSchoolName].UserPoolId;
      var Logins = {};
      Logins[login] = idToken;

      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: schoolConstants[localStorage.zmailSchoolName].IdentityPoolId,
        Logins: Logins,
      });

      //FIXES THE ISSUE OF A CACHED ID FOR NEW USERS ON SAME COMPUTER.
      AWS.config.credentials.clearCachedId();

      AWS.config.credentials.get(function (err) {
        if (err) {
          reject(err);
        } else {
          // @TODO
          // dispatch({type: "LOADED_CREDENTIALS"});
          resolve();
        }
      });
    });
  });

  return credentialsPromise;
}

export default getCredentials;



// WEBPACK FOOTER //
// ./src/authentication/getCredentials.js